<div *ngIf=!showloader class="content-wrapper">

  <div class="mainDiv">

    <table style="margin-top:5px;" id="currentSelectTable" cellspacing="0" cellpadding="2" width="95%">
  <tbody>
      <tr>
  <td colspan="2">
    <div class="d-flex justify-content-end align-items-center mb-2" style="width: 100%; padding-right: 15px;">

      <button class="btn btn-link1 shadow-none need1"
              (click)="openHelp()"
              style="margin-right: 20px; text-decoration: none; color: purple; font-weight: 500; border: none; background: none; font-size: 11px;">
        {{'Need help with'|translate}}:&nbsp;{{'Vehicle Sessions'|translate}}?
      </button>
      <i class="fa fa-file-pdf-o me-3"
         (click)="downloadPageAsPdf()"
         title="Download PDF"
         style="cursor: pointer; font-size: 1.3rem; color: #d32f2f;">
      </i>

      <i class="fa fa-print"
         (click)="printPageNative()"
         title="Print Page"
         style="cursor: pointer; font-size: 1.3rem; color: #003399;">
      </i>
    </div>
  </td>
</tr>
    <tr>
          <td>
            <p class="para" style="font-size: 10pt;"> {{'currentSelectedvehicle'|translate}}.</p>

            <!-- <p class="para"><a href="/services/hotline/rvcGenerator.do">RVC Generator</a></p> -->

          </td>
        </tr>


        <tr>
          <td>
            <p class="para" style="font-size: 10pt;">
              <b>{{'Service Reception Stored Diagnostic Sessions'|translate}}</b>

            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span class="pagebanner" style="font-size: 12.8px;">{{indcount}} {{'itemInfo'|translate}}
              {{firstnumber}} {{'to'|translate}}
              {{secondnumber}}.
              <br>
              <div>
                <pagination-controls [maxSize]="maxSize" previousLabel="{{'Previous'|translate}}"
                  nextLabel="{{'Next'|translate}}" [directionLinks]="directionLinks" [autoHide]="autoHide"
                  [responsive]="responsive" (pageChange)="pageChanged($event);q=$event" class="my-pagination" id="d">
                </pagination-controls>
              </div>
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <table border="0" cellpadding="0" cellspacing="0" width="83%">
              <thead style="font-size: 10pt;">
                <tr>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Dates'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Start Time'|translate}} [UK-Time]</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Dealer Code'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Technician'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'State'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Mobile Van'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                </tr>
              </thead>
              <tbody style="font-size: 10pt;" *ngIf=!showloader>
                <tr *ngFor="let session of serviceList|paginate:{
            itemsPerPage: 20,
            currentPage: q,
            totalItems: serviceList.length,
            id:'d'};let ii=index" [ngClass]="ii%2==0?'tab1':'tabClass'" class="rowClass">
                  <td>&nbsp;</td>
                  <td *ngIf="countryCode != 'GBR'">{{session.date}}</td>
                  <td *ngIf="countryCode == 'GBR'">{{session.date | date: 'dd/MM/yyyy'}}</td>
                  <td>{{session.time}}</td>
                  <td>

                    {{session.dealerCode}}

                  </td>
                  <td>{{session.technicianId}}</td>
                  <td>{{session.state}}</td>
                  <td>{{session.mobileVan}}</td>
                  <td>
                    <form action="" method="GET">
                      <input type="hidden" name="org.apache.struts.taglib.html.TOKEN"
                        value="4153bfa56cea747609d37fe4123962db">

                      <input type="button" class="sessionbuttons1" value="{{'View'|translate}}" id="sessionViewButton1"
                        (click)="viewSession(session.createTimeStamp,'',false)">
                    </form>
                  </td>
                  <td>
                    <i class="fa fa-download" *ngIf="isAdmin" style="cursor: pointer;"
                      (click)="downloadSession(session.createTimeStamp,'')"></i>
                  </td>
                  <td
                    *ngIf="session.state!='Repair completed' && session.state!='Qualifying vehicle' && session.state!='Service Reception closed'">
                    <form action="/diagnostic/onlineDiagnosis.do">
                      <input type="submit" (click)="resumeSession(session, content)"
                             [disabled]="session.isMobileVehicle ? false : ((session.technicianId != userName && userType == 'FORD_INTERNAL') && (session.dealerCode != tempDealerCode))"
                             value="{{'RESUME SESSION'|translate}}">

                    </form>
                  </td>

                </tr>
              </tbody>
            </table>
            <div style="font-size: 10pt;" *ngIf="!showloader && noServiceData">
              No Data Found
            </div>
          </td>
        </tr>
        <br>
        <tr>
          <td>
            <p class="para" style="font-size: 10pt;">
              <b>{{'Pending sessions being sent to Central Diagnostic Store'|translate}}</b>

            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span class="pagebanner" style="font-size: 12.8px;">{{indcount2}} {{'itemInfo'|translate}}
              {{firstnumber2}} {{'to'|translate}}
              {{secondnumber2}}.
              <br>
              <div>
                <pagination-controls [maxSize]="maxSize" previousLabel="{{'Previous'|translate}}"
                  nextLabel="{{'Next'|translate}}" [directionLinks]="directionLinks2" [autoHide]="autoHide2"
                  [responsive]="responsive2" (pageChange)="pageChanged2($event);q=$event" class="my-pagination" id="d2">
                </pagination-controls>
              </div>
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <table border="0" cellpadding="0" cellspacing="0" width="83%">
              <thead style="font-size: 10pt;">
                <tr>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Dates'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Start Time'|translate}} [UK-Time]</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Dealer Code'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Technician'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'State'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                </tr>
              </thead>
              <tbody style="font-size: 10pt;" *ngIf=!showloader>
                <tr *ngFor="let session of serviceListInprogress|paginate:{
            itemsPerPage: 20,
            currentPage: q2,
            totalItems: serviceListInprogress.length,
            id:'d2'};let ii=index" class="rowClass">
                  <td>&nbsp;</td>
                  <td *ngIf="countryCode != 'GBR'">{{session.date}}</td>
                  <td *ngIf="countryCode == 'GBR'">{{session.date | date: 'dd/MM/yyyy'}}</td>
                  <td>{{session.time}}</td>
                  <td>

                    {{session.dealerCode}}

                  </td>
                  <td>{{session.technicianId}}</td>
                  <td>{{session.state}}</td>
                  <td>
                    <form>
                      <input type="hidden">

                      <input type="button" class="sessionbuttons1" value="{{'View'|translate}}" id="sessionViewButton1"
                        (click)="viewSession(session.createTimeStamp,'',false)">
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="font-size: 10pt;" *ngIf="!showloader && noServiceInprogressData">
              No Data Found
            </div>
          </td>
        </tr>
        <br>
        <tr>
          <td>
            <p style="font-size: 10pt;">
              <b>{{'Centrally Stored Diagnostic Sessions'|translate}}</b>

            <p></p>
          </td>
        </tr>
        <tr>
          <label style="font-size : 12.8px;font-family : Verdana,Arial,Helvetica,Trebuchet,_sans">{{'Session
            source'|translate}}: </label>&nbsp;
          <select style="font-size : 13.33px; border-width: 1px; background-color: #FFFFFF; color: #000000;"
            name="sessionSource" [(ngModel)]="sessionSource">
            <option value="ALL" selected="selected">{{'All'|translate}}</option>
            <option value="FORD_ETIS_IDS">Etis-IDS</option>
            <option value="SBDO_Service">SBDO_Service</option>
            <option value="FORD_ETIS_ONLINE">SBD-Online</option>
            <option value="FDRS">FDRS</option>
            <option value="GFDRS">GFDRS</option>
          </select>&nbsp;
          <input type="button" class="sessionbuttons2" style="font-size:12.8px;" (click)="filter()"
            value="{{'FILTER'|translate}}">&nbsp;
        </tr>
        <tr>
          <td>
            <span class="pagebanner" style="font-size: 12.8px;">{{indcount1}} {{'itemInfo'|translate}}
              {{firstnumber1}} {{'to'|translate}}
              {{secondnumber1}}.
              <br>
              <div>
                <pagination-controls [maxSize]="maxSize1" previousLabel="{{'Previous'|translate}}"
                  nextLabel="{{'Next'|translate}}" [directionLinks]="directionLinks1" [autoHide]="autoHide1"
                  [responsive]="responsive1" (pageChange)="pageChanged1($event);q1=$event" class="my-pagination"
                  id="d1">
                </pagination-controls>
              </div>
            </span>
          </td>

        </tr>
        <tr>
          <td colspan="2">
            <table border="0" cellpadding="0" cellspacing="0" width="100%">
              <thead style="font-size: 10pt;">
                <tr>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Dates'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Start Time'|translate}} [UK-Time]</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Dealer Code'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Technician'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'State'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'RVC'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    {{'Method'|translate}}</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                  <th style="background-color:#003F87;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:left;">
                    &nbsp;</th>
                </tr>
              </thead>
              <tbody style="font-size: 10pt;" *ngIf="!showloader && !showCSDloader">
                <tr *ngFor="let i of centralList|paginate:{
            itemsPerPage: 20,
            currentPage: q1,
            totalItems: totalSize,
            id:'d1'};let ii=index" [ngClass]="ii%2==0?'tab2':'tabClass1'" class="rowClass">
                  <td>&nbsp;</td>
                  <td *ngIf="countryCode != 'GBR'">{{i.date}}</td>
                  <td *ngIf="countryCode == 'GBR'">{{i.date | date: 'dd/MM/yyyy'}}</td>
                  <td>{{i.time}}</td>
                  <td>{{i.warrantyDealerCode}}</td>
                  <td>{{i.technicianId}}</td>

                  <td>{{i.state}}</td>

                  <td>{{i.rvcCodeNew|translate}}</td>
                  <td>
                    <span *ngIf="i.indictmentMethod== 'manualTechnician'"><img
                        src="/assets/images/technician.jpg"></span>
                    <span *ngIf="i.indictmentMethod== 'automatic'"><img src="/assets/images/automatic.jpg"></span>
                    <span *ngIf="i.indictmentMethod== 'automaticNoVCM'"><img src="/assets/images/novcm.jpg"></span>
                    <span *ngIf="i.indictmentMethod== 'automaticNoVMM'"><img src="/assets/images/novmm.jpg"></span>
                    <span *ngIf="i.indictmentMethod== 'automaticNoRVC'"><img src="/assets/images/norvc.jpg"></span>
                    <span *ngIf="i.indictmentMethod== 'manualHotline'"><img src="/assets/images/hotline.jpg"></span>
                  </td>
                  <td>
                    <form action="" method="GET">
                      <input type="hidden" name="org.apache.struts.taglib.html.TOKEN"
                        value="4153bfa56cea747609d37fe4123962db">

                      <input type="button" class="sessionbuttons2" id="summaryView2051" value="{{'View'|translate}}"
                        (click)="viewSession(i.createTimeStamp,i.sessionSource,true)">
                    </form>
                  </td>
                  <td>
                    <i class="fa fa-download" *ngIf="isAdmin" style="cursor: pointer;"
                      (click)="downloadSession(i.createTimeStamp,i.sessionSource)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="font-size: 10pt;" *ngIf="!showloader && !showCSDloader && noCentralData">
              No Data Found
            </div>
            <div *ngIf=showCSDloader class="loader2">
              <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #content let-modal>
  <div *ngIf=!showloader class="modal-content">
    <div class="modal-header">
      <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">
        {{'Information'|translate}}</div>
      <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="deleteContent info-s">
      <p>{{'Diagnosis and Repair info'|translate}}</p>
    </div>
    <div class="modal-footer">

      <button type="button" class="buttons" (click)="modal.dismiss('Cross click')">{{'Continue'|translate}}</button>

    </div>
  </div>
</ng-template>

<div *ngIf=showloader class="loader2">
  <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
</div>
<!-- <div id="show" style="display:none">
<p>Hi</p>
</div> -->
<ng-template #noRVCMsgDesc let-modal>
  <div class="container version">
    <div class="row popup-header" style="margin-top: 0%;">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true" *ngIf="!isButtonEnabled"
                                                            (click)="modal.dismiss('noRVCMsgDesc')"></i></div>
    </div>
    <div>
      <label class='msg-body'>
        <p class="norvg-msg">{{'norvc_req_description_msg' | translate}}</p>
      </label>
    </div>
    <hr class="hr-line1">
    <div class="popup-footer">
      <button type="button" class="btn btn-primary mr-3 pull-right confirm" name="confirm"  [disabled]="isButtonEnabled"
              (click)="modal.dismiss('noRVCMsgDesc')">{{'Confirm'|translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #mobileVanModal let-modal>
  <div
    class="dialog widget widget-content corner-all front dialog-buttons draggable mobilevan-dialog"
    style="height:auto; width:640px; display:block;"
  >
    <div class="dialog-titlebar widget-header corner-all">
      <i class="fa fa-times fa-lg close2" (click)="modal.dismiss('close')" title="close"></i>
    </div>

    <div class="dialog-content mobilevan-msg">
      {{ 'Is this still a roadside assistance/ mobile van session?' | translate }}
    </div>

   <div class="dialog-buttonpane">
  <div class="mobilevan-btn-row">
    <button class="mobilevan-btn" (click)="modal.close(true)"><span>{{'No'|translate}}</span></button>
    <button class="mobilevan-btn" (click)="modal.close(false)"><span>{{'Yes'|translate}}</span></button>
  </div>
</div>

  </div>
</ng-template>




